import React from 'react'
import { Construction, ArrowLeft, Home } from 'lucide-react'
import Button from './ui/Button'

const UnderConstruction = ({ pageName = "Esta Página" }) => {
  return (
    <div className="pt-32 pb-16 min-h-screen bg-gradient-to-br from-gardenia-red/5 via-gardenia-gold/5 to-gardenia-green/5">
      <div className="container-custom px-4">
        <div className="text-center max-w-2xl mx-auto">
          {/* Animated Icon */}
          <div className="mb-8 relative">
            <div className="inline-flex items-center justify-center w-32 h-32 rounded-full bg-gradient-to-r from-gardenia-red to-gardenia-green shadow-2xl mb-6 animate-bounce-soft">
              <Construction className="h-16 w-16 text-white animate-pulse" />
            </div>
            {/* Decorative elements */}
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-40 h-40 bg-gardenia-gold/20 rounded-full blur-3xl animate-pulse"></div>
          </div>

          {/* Title */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gardenia-dark mb-6 animate-fade-in-up">
            {pageName}
            <span className="text-gradient block mt-2">En Construcción</span>
          </h1>

          {/* Description */}
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed mb-8 animate-fade-in-up">
            Estamos trabajando arduamente para traerte contenido de calidad. 
            Esta sección estará disponible muy pronto.
          </p>

          {/* Progress Bar Animation */}
          <div className="mb-12 max-w-md mx-auto animate-fade-in-up">
            <div className="h-3 bg-gray-200 rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-gardenia-red via-gardenia-gold to-gardenia-green animate-progress rounded-full"></div>
            </div>
            <p className="text-sm text-gray-500 mt-3">Cargando contenido...</p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up">
            <Button 
              onClick={() => window.history.back()}
              variant="outline"
              size="lg"
              className="inline-flex items-center space-x-2"
            >
              <ArrowLeft className="h-5 w-5" />
              <span>Volver Atrás</span>
            </Button>
            <Button 
              to="/"
              size="lg"
              className="inline-flex items-center space-x-2"
            >
              <Home className="h-5 w-5" />
              <span>Ir al Inicio</span>
            </Button>
          </div>

          {/* Additional Info */}
          <div className="mt-12 p-6 bg-white rounded-xl shadow-lg border border-gray-100 animate-fade-in-up">
            <p className="text-gray-600 mb-4">
              Mientras tanto, puedes explorar otras secciones:
            </p>
            <div className="flex flex-wrap gap-3 justify-center">
              <Button to="/nosotros" variant="ghost" size="sm">
                Nosotros
              </Button>
              <Button to="/programas" variant="ghost" size="sm">
                Programas
              </Button>
              <Button to="/admisiones" variant="ghost" size="sm">
                Admisiones
              </Button>
              <Button to="/contacto" variant="ghost" size="sm">
                Contacto
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UnderConstruction